import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { FiEye, FiEyeOff } from "react-icons/fi";
import "../../assets/css/login.css";

const NODE_COUNT = 42;
const ALERT_EVERY = 7;

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { login, isLoading, alertMessage } = useContext(AuthContext);

  const logo = require("../../assets/images/logo/logo.png");

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage("");

    login({ email, password }).catch((err) => {
      setErrorMessage(
        err.response?.data?.message || "Email ou mot de passe incorrect !",
      );
    });
  };

  const feedback = errorMessage
    ? { type: "danger", text: errorMessage }
    : alertMessage
      ? { type: alertMessage.type, text: alertMessage.text }
      : null;

  return (
    <div className="login-screen">
      {/* ---- Fond : grille de signaux surveillés ---- */}
      <div className="login-nodes" aria-hidden="true">
        <div className="login-nodes-sweep"></div>
        {Array.from({ length: NODE_COUNT }).map((_, i) => (
          <span
            key={i}
            className={`login-node${
              i % ALERT_EVERY === 0 ? " login-node--alert" : ""
            }`}
          />
        ))}
      </div>

      <div className="login-stage">
        {/* ---- Pitch produit ---- */}
        <div className="login-pitch">
          <div className="login-brand">
            <img src={logo} alt="SpyTeam" className="login-brand-logo" />
            <span className="login-brand-name">SpyTeam</span>
          </div>

          <span className="login-eyebrow">Plateforme de supervision</span>
          <h1 className="login-headline">
            Chaque poste,
            <br />
            sous contrôle en temps réel.
          </h1>
          <p className="login-subtext">
            Activité, historique, alertes : visibilité continue sur l'ensemble
            de votre parc, sans angle mort.
          </p>

          <div className="login-status">
            <span className="login-status-dot"></span>
            Système en ligne
          </div>
        </div>

        {/* ---- Carte de connexion ---- */}
        <div className="login-card">
          <div className="login-card-header d-lg-none">
            <img src={logo} alt="SpyTeam" className="login-brand-logo" />
            <span className="login-brand-name">SpyTeam</span>
          </div>

          <h2 className="login-title">Connexion</h2>
          <p className="login-lead">
            Entrez vos identifiants pour accéder à votre espace.
          </p>

          <form onSubmit={handleSubmit} noValidate>
            <div className="login-field">
              <label htmlFor="login-email">Adresse email</label>
              <input
                id="login-email"
                type="email"
                name="email"
                placeholder="vous@entreprise.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>

            <div className="login-field">
              <label htmlFor="login-password">Mot de passe</label>
              <div className="login-input-wrap">
                <input
                  id="login-password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="login-eye"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={
                    showPassword
                      ? "Masquer le mot de passe"
                      : "Afficher le mot de passe"
                  }
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>

            {feedback && (
              <div className={`login-alert login-alert--${feedback.type}`}>
                {feedback.text}
              </div>
            )}

            <div className="login-row">
              <label className="login-remember">
                <input type="checkbox" />
                Se souvenir de moi
              </label>
              <Link className="login-forgot" to="/forgot-password">
                Mot de passe oublié ?
              </Link>
            </div>

            <button className="login-submit" type="submit" disabled={isLoading}>
              {isLoading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                />
              ) : (
                "Se connecter"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
